import React from 'react';
import './FeedPosts.css';
import {Avatar, Button} from '@material-ui/core';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import HowToVoteIcon from '@material-ui/icons/HowToVote';
import ShareIcon from '@material-ui/icons/Share';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { Dropdown } from 'react-bootstrap';
import TurnedInNotIcon from '@material-ui/icons/TurnedInNot';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import db from './firebase';

function FeedPosts({userId, postId, 
    name, profile, message, timestamp, 
    image, like, likeObj, likeScore}) {
    const deletePost = () => {
        const deleteKey = document.getElementById(`${postId}`).id;
        db.collection('posts').doc(deleteKey).delete()
    }
    
    const likePost = () => {
        const likeKey = document.getElementById(`${postId}`).id;
        const twit = () => ({
            [x] : true
        })
        const x = userId
        db.collection('posts').doc(likeKey).update({
            like: {...likeObj, ...twit(x)},
            likeScore : likeScore + 1
        })
    }
    const unlikePost = () => {
        const likeKey = document.getElementById(`${postId}`).id;
        var final = likeObj
        delete(final[`${userId}`])
        db.collection('posts').doc(likeKey).update({
            like: final, 
            likeScore: likeScore - 1
        })
    }
        
    return (
        <div className="feedPosts" id={postId}>
            <div className="post__top">
                <Avatar src={profile}
                className="post__avatar" />
                <div className="post__topInfo">
                    <h3>{name}</h3>
                    <p>{new Date(timestamp?.toDate()).toDateString()+" "+
                    new Date(timestamp?.toDate()).toLocaleTimeString()}</p>
                </div>
                <div className="post__opts">
                <Dropdown className="more__down m__down">
                    <Dropdown.Toggle className="more__expand" id="dropdown-basic">
                        <MoreHorizIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={deletePost}><DeleteForeverIcon/> Delete</Dropdown.Item>
                        <Dropdown.Item ><TurnedInNotIcon/> Pin</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown> 
                    
                </div>
            </div>
            <div className="post__bottom">
                <p>{message} </p>
            </div>

            <div className="post__image">
                <img src={image} alt="" />
            </div>

            <div className="post__options cco">
                <div className="post__option count">
                    <p>{likeScore} 
                    <img id="imgId"
                    className={likeScore <= 0 && "hide__heart"}
                    src="image/heart.png" width="15px" 
                    /> Like</p>
                </div>
                <div className="post__option count ount">
                    <p>0 Comment</p>
                </div>
            </div>
            <div className="post__options" >
                <div className="post__option" onClick={like? unlikePost:likePost}>
                    {like? <FavoriteIcon 
                    className="heart__color"
                    
                    /> : <FavoriteBorderIcon className="unlike__color"/> }
                    <p>Like</p>
                </div>
                <div className="post__option">
                    <HowToVoteIcon />
                    <p>Comment</p>
                </div>
                <div className="post__option reduce__post">
                    <ShareIcon />
                    <p>Share</p>
                </div>
            </div>
        </div>
    )
}

export default FeedPosts
